// extracted by mini-css-extract-plugin
export default {"container":"F8DiLml8aqVhEnh6gvzM","backButton":"qGMgSTyH1B0mfzHHLclY","backLabel":"vq6E7ysJ0qOQO8tSPeJU"};